import React from 'react'

const NitradingDueReport = () => {
  return (
    <div>NitradingDueReport</div>
  )
}

export default NitradingDueReport